import React, { useState, useEffect, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import styles from './style.module.css';
import { CircularProgress } from '@mui/material';
import MobileContext from 'context/MobileContext';
import Header from './Header';
import { fileDownload } from 'assets/icons';

const PaymentConfirmationSection = ({
  loadMembershipAgreementPDF,
  isPDFDownloading,
  eSignedData,
  receiptPdfData,
  receiptPDF,
  membershipAgreementPDF,
}) => {
  const isMobile = useContext(MobileContext);
  // const { location: gymName } = useParams();
  const history = useHistory();
  const location = useLocation();
  const paymentStatus = localStorage.getItem('payment');

  const [paymentDetails] = useState(
    location.state?.paymentDetails?.newUserData
      ? location.state?.paymentDetails?.newUserData
      : location.state?.paymentDetails?.data
  );
  const [selectedClub] = useState(location.state?.selectedClub);
  const [selectedPlanType] = useState('membership');
  const [descriptionText] = useState(location.state?.membershipTextData);
  // const [selectedPlanName] = useState(location.state?.selectedPlanName);
  const [isLoading, setIsLoading] = useState(true);

  const backgroundStyle = {
    backgroundImage: `${
      isMobile
        ? 'linear-gradient(0deg, rgba(0, 0, 0, 0.70) 0%, rgba(0, 0, 0, 0.70) 100%)'
        : 'linear-gradient(0deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.50) 100%)'
    }, url(${isMobile ? selectedClub?.olsBgMobile : selectedClub?.olsBgDesktop})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'scroll',
    minHeight: isMobile ? 'calc(100vh - 60px)' : '100vh',
    position: 'relative',
  };

  useEffect(() => {
    if (paymentStatus === 'completed') {
      const timer = setTimeout(() => {
        window.location.replace('/');
        localStorage.setItem('payment', 'inCompleted');
      }, 30000);

      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    if (!paymentDetails) {
      window.location.replace('/');
      localStorage.setItem('payment', 'inCompleted');
    } else {
      history.replace({
        pathname: location.pathname,
        state: {},
      });
    }
  }, [paymentDetails]);

  // useEffect(() => {
  //   if (
  //     Object.keys(eSignedData).length > 0 &&
  //     Object.keys(receiptPdfData).length > 0 &&
  //     paymentDetails?.userId
  //   ) {
  //     const payload = {
  //       caId: paymentDetails?.userId,
  //     };
  //     loadMembershipAgreementPDF(payload);
  //   }
  // }, [eSignedData, receiptPdfData, paymentDetails?.userId, loadMembershipAgreementPDF]);

  // Utility function to download PDF from base64 data
  // const downloadPDFFromData = (base64Data, fileName) => {
  //   try {
  //     // Convert base64 string to a Blob
  //     const byteCharacters = atob(base64Data);
  //     const byteNumbers = new Array(byteCharacters.length);
  //     for (let i = 0; i < byteCharacters.length; i++) {
  //       byteNumbers[i] = byteCharacters.charCodeAt(i);
  //     }
  //     const byteArray = new Uint8Array(byteNumbers);
  //     const blob = new Blob([byteArray], { type: 'application/pdf' });

  //     // Create blob URL and trigger download
  //     const blobUrl = URL.createObjectURL(blob);
  //     const link = document.createElement('a');
  //     link.href = blobUrl;
  //     link.download = `${fileName}.pdf`;
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);

  //     // Clean up
  //     URL.revokeObjectURL(blobUrl);
  //   } catch (error) {
  //     console.error('Error downloading PDF:', error);
  //   }
  // };

  // const handleDownloadPDF = documentType => {
  //   // Check if we have the PDF data stored
  //   const pdfData = documentType === 'receipt' ? receiptPDF : membershipAgreementPDF;

  //   if (pdfData && pdfData.base64Data) {
  //     downloadPDFFromData(pdfData.base64Data, pdfData.fileName);
  //   } else {
  //     // If data not available, trigger prefetch again
  //     const payload = {
  //       caId: paymentDetails?.userId,
  //     };
  //     loadMembershipAgreementPDF(payload);
  //   }
  // };

  // Loader component for download buttons
  const Loader = () => <CircularProgress size={20} style={{ color: '#fe5000' }} />;

  // // Local loading state for both receipt and agreement
  // useEffect(() => {
  //   if (
  //     Object.keys(receiptPDF).length > 0 &&
  //     Object.keys(membershipAgreementPDF).length > 0
  //   ) {
  //     setIsLoading(false);
  //     // Set timeout after all PDFs are loaded
  //     const timer = setTimeout(() => {
  //       window.location.replace('/');
  //       localStorage.setItem('payment', 'inCompleted');
  //     }, 60000);
  //     return () => clearTimeout(timer); // Cleanup timeout on unmount
  //   } else {
  //     setIsLoading(true);
  //   }
  // }, [receiptPDF, membershipAgreementPDF]);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.fixedHeader}>
        <Header />
      </div>
      <div
        className={
          selectedPlanType !== 'pass'
            ? styles.scrollableContentMembership
            : styles.scrollableContentPass
        }
        style={paymentDetails ? backgroundStyle : {}}
      >
        {!paymentDetails ? (
          <div className={styles.progressbarDiv}>
            <CircularProgress
              className={styles.circularProgress}
              style={{ color: '#fe5000' }}
            />
          </div>
        ) : (
          <div className={styles.wrapper}>
            {selectedPlanType !== 'pass' ? (
              // Non-pass membership UI
              <div
                className={`${styles.overlayContent} ${isMobile ? styles.mobile : ''}`}
                style={
                  !isMobile
                    ? {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-around',
                        width: '100%',
                        position: 'relative',
                        zIndex: 1,
                      }
                    : {
                        position: 'relative',
                        zIndex: 1,
                      }
                }
              >
                {/* Left Column for Text Content */}
                <div className={`${!isMobile ? styles.leftColumnMembership : ''}`}>
                  <h1
                    className={`${styles.membershipWelcomeHeading} ${
                      isMobile ? styles.mobile : ''
                    }`}
                  >
                    Thanks for Joining <br /> FITNESS SF!
                  </h1>
                  <p
                    className={`${styles.membershipWelcomeSubheading} ${
                      isMobile ? styles.mobile : ''
                    }`}
                  >
                    You'll receive a confirmation email <br />
                    with next steps.
                  </p>
                </div>

                {/* Right Column for Purchase Summary Card */}
                <div
                  className={styles.row2}
                  style={!isMobile ? { flexBasis: '40%' } : {}}
                >
                  <div className={`${styles.grid4} ${isMobile ? styles.mobile : ''}`}>
                    <>
                      <div className={styles.firstHeadingContainer}>
                        <p className={styles.firstHeading}>Your Purchase Summary:</p>
                      </div>
                      <div className={styles.firstDivider}></div>
                    </>

                    <div className={styles.planContainer}>
                      <p
                        className={`${styles.mainHeading} ${
                          isMobile ? styles.mobile : ''
                        }`}
                      >
                        Membership Plan
                      </p>
                      <p className={styles.content}>{paymentDetails?.itemName}</p>
                      <p className={styles.passDate}>
                        Start Date: {paymentDetails?.starting}
                      </p>
                    </div>
                    <div className={styles.header}>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          fontWeight: 0,
                        }}
                      >
                        <p
                          style={{ textDecoration: 'none', lineHeight: '30px' }}
                          className={`${styles.duesHeading} ${
                            isMobile ? styles.mobile : ''
                          }`}
                        >
                          Monthly Dues
                        </p>
                        <p className={styles.text2}>{descriptionText?.monthlyDuesText}</p>
                      </div>
                      <p
                        style={{ marginTop: '7px' }}
                        className={`${styles.text} ${isMobile ? styles.mobile : ''}`}
                      >
                        {paymentDetails?.enrollmentFee}
                      </p>
                    </div>
                    <div
                      className={`${styles.membershipDivider} ${
                        isMobile ? styles.mobile : ''
                      }`}
                    ></div>

                    <div
                      className={`${styles.totalAmtWrapper} ${
                        isMobile ? styles.mobile : ''
                      }`}
                    >
                      {isMobile ? (
                        <p
                          style={{
                            textDecoration: 'none',
                            padding: '25px 0px 0px 30px',
                          }}
                          className={styles.text3}
                        >
                          Due Today
                        </p>
                      ) : (
                        ''
                      )}
                      <div
                        style={
                          isMobile
                            ? {
                                marginTop: '20px',
                              }
                            : {
                                marginTop: '10px',
                              }
                        }
                        className={styles.contentWrapper}
                      >
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            fontWeight: 0,
                          }}
                        >
                          <p
                            style={{ textDecoration: 'none', lineHeight: '30px' }}
                            className={styles.contentHeading}
                          >
                            Prorated 1st month dues
                          </p>
                          <p className={styles.text2} style={{ paddingLeft: '30px' }}>
                            {descriptionText?.proratedText}
                          </p>
                        </div>
                        <p
                          style={{ marginTop: '7px', paddingRight: '30px' }}
                          className={styles.text}
                        >
                          {paymentDetails?.membershipFee}
                        </p>
                      </div>
                      <div
                        className={styles.contentWrapper}
                        style={{ marginTop: '10px', marginBottom: '15px' }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            fontWeight: 0,
                          }}
                        >
                          <p
                            style={{ textDecoration: 'none', lineHeight: '30px' }}
                            className={styles.contentHeading}
                          >
                            Last month dues
                          </p>
                          <p className={styles.text2} style={{ paddingLeft: '30px' }}>
                            {descriptionText?.lastMonthText}
                          </p>
                        </div>
                        <p
                          style={{ marginTop: '7px', paddingRight: '30px' }}
                          className={styles.text}
                        >
                          {paymentDetails?.enrollmentFee}
                        </p>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'space-between',
                        }}
                      >
                        <p className={styles.totalAmtHeading}>Total Paid</p>
                        <p className={styles.totalAmtContent}>
                          {paymentDetails?.totalDue}
                        </p>
                      </div>
                    </div>

                    {/* Common divider and download section */}
                    {/* <div
                      className={`${styles.membershipDivider} ${
                        isMobile ? styles.mobile : ''
                      }`}
                    ></div>
                    <div className={styles.downloadWrapper}>
                      <div className={styles.downloadContainer}>
                        <p>Download Receipt</p>
                        {isLoading ? (
                          <Loader />
                        ) : (
                          <img
                            src={fileDownload}
                            alt=""
                            onClick={() => handleDownloadPDF('receipt')}
                          />
                        )}
                      </div>
                      <div className={styles.downloadContainer}>
                        <p>Download Membership Agreement</p>
                        {isLoading ? (
                          <Loader />
                        ) : (
                          <img
                            src={fileDownload}
                            alt=""
                            onClick={() => handleDownloadPDF('membership-agreement')}
                          />
                        )}
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            ) : (
              // Pass membership UI
              <div
                className={`${styles.passOverlayContent} ${
                  isMobile ? styles.mobile : ''
                }`}
                style={{ position: 'relative', zIndex: 1 }}
              >
                <h1
                  className={`${styles.welcomeHeading} ${
                    isMobile ? styles.mobile : ''
                  }  `}
                >
                  Looking forward to {isMobile ? <br /> : ''} seeing you!
                </h1>
                <p
                  className={`${styles.welcomeSubheading} ${
                    isMobile ? styles.mobile : ''
                  }`}
                >
                  You'll receive a confirmation email {isMobile ? <br /> : ''} shortly
                  with next steps.
                </p>

                <div className={styles.row2}>
                  <div className={`${styles.grid4} ${isMobile ? styles.mobile : ''}`}>
                    <>
                      <div className={styles.firstHeadingContainer}>
                        <p className={styles.firstHeading}>Your Purchase Summary:</p>
                      </div>
                      <div className={styles.firstDivider}></div>
                    </>

                    <div className={styles.planContainer}>
                      <p
                        className={`${styles.mainHeading} ${
                          isMobile ? styles.mobile : ''
                        }`}
                      >
                        Membership Plan
                      </p>
                      {/* <p className={styles.passContent}>{selectedPlanName}</p> */}
                      <p className={styles.passDate}>
                        Valid through {paymentDetails?.starting} -{' '}
                        {paymentDetails?.ending}
                      </p>
                    </div>
                    <div
                      className={`${styles.membershipDivider} ${
                        isMobile ? styles.mobile : ''
                      }`}
                      style={{ marginTop: '15px', marginBottom: '15px' }}
                    ></div>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        marginBottom: '20px',
                      }}
                    >
                      <p className={styles.totalAmtHeading}>Total Paid</p>
                      <p className={styles.totalAmtContent}>{paymentDetails?.totalDue}</p>
                    </div>

                    {/* Common divider and download section */}
                    <div
                      className={`${styles.membershipDivider} ${
                        isMobile ? styles.mobile : ''
                      }`}
                    ></div>
                    <div className={styles.downloadWrapper}>
                      <div className={styles.downloadContainer}>
                        <p>Download Receipt</p>
                        {isLoading ? (
                          <Loader />
                        ) : (
                          <img
                            src={fileDownload}
                            alt=""
                            // onClick={() => handleDownloadPDF('receipt')}
                          />
                        )}
                      </div>
                      <div className={styles.downloadContainer}>
                        <p>Download Membership Agreement</p>
                        {isLoading ? (
                          <Loader />
                        ) : (
                          <img
                            src={fileDownload}
                            alt=""
                            // onClick={() => handleDownloadPDF('membership-agreement')}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentConfirmationSection;
